import { getLocation } from '@change-corgi/core/window';

import { useTrackView } from '#src/app/shared/hooks/tracking';

type Result = ModelHookResult<
	undefined,
	{
		reload: () => void;
	}
>;

export function useMaintenanceContainer(): Result {
	useTrackView('search_v2_maintenance');

	return {
		actions: {
			reload: () => {
				getLocation().reload();
			},
		},
	};
}
